"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systemComponents_1 = require("@/store/ducks/systemComponents");
const systems_1 = require("@/services/systems");
const systems_2 = require("@/store/ducks/systems");
function deleteSystemComponentAssociationUseCase(systemId, componentId) {
    return async (dispatch) => {
        dispatch((0, systemComponents_1.deleteAssociation)());
        try {
            await (0, systems_1.patchSystemComponents)(systemId, {
                componentsToAssociate: { remove: [componentId] },
            });
            dispatch((0, systemComponents_1.deleteAssociationSuccess)());
            dispatch((0, systemComponents_1.closeDeleteAssociationModal)());
            dispatch((0, systems_2.openSystemToast)({ status: "success", message: "Component deleted" }));
        }
        catch (e) {
            dispatch((0, systemComponents_1.deleteAssociationError)());
            dispatch((0, systems_2.openSystemToast)({
                status: "error",
                message: "Error deleting component",
            }));
        }
    };
}
exports.default = deleteSystemComponentAssociationUseCase;
